<template>
  <div class="container p-0" v-show="!hidden">
    <div class="input-group has-validation">
      <input :ref="'inputField_' + element.name" :value="value" @input="elementChanged" @blur="elementChanged" type="number"
        :step="getStepValue()" :id="ids.input" :name="element.name" :autocomplete="element.autocomplete || 'on'" class="form-control"
        :placeholder="getTextFor(element.placeholder, lang)" :required="element.required" :aria-describedby="describedBy" :aria-invalid="ariaInvalid" :disabled="hidden">
    </div>
    <div class="invalid-feedback" :id="ids.error" :style="invalidStyle">{{ getTextFor(element.invalid, lang) }}</div>
    <div v-if="heeftUitleg" :id="ids.help" class="form-text">{{ getTextFor(element.explanation, lang) }}</div>
  </div>
</template>

<script>
import veldToegankelijkheid from '../../utils/veldToegankelijkheid'

export default {
  mixins: [veldToegankelijkheid],
  name: 'FormElementNumberInput',
  props: ['element', 'lang', 'targetId', 'wasValidated', 'value', 'hidden'],
  emits: ['elementChanged'],
  watch: {
    hidden(value) {
      console.log(`${this.element.name} hidden: `, value)
    }
  },
  methods: {
    getStepValue() {
      // Als useStep false is, gebruik geen step attribuut (any value allowed)
      if (this.element.useStep === false) {
        return 'any';
      }
      
      // Als useStep true is en step is ingesteld, gebruik die
      if (this.element.useStep && this.element.step) {
        return this.element.step;
      }
      
      // Backwards compatibility: als element.step is ingesteld, gebruik die
      if (this.element.step) {
        return this.element.step;
      }
      
      // Auto-detect voor lat/lng velden gebaseerd op naam of waarde
      const name = this.element.name ? this.element.name.toLowerCase() : '';
      const isLatLng = name.includes('lat') || name.includes('lng') || name.includes('lon') || 
                      name.includes('longitude') || name.includes('latitude') ||
                      (typeof this.value === 'number' && Math.abs(this.value) > 1 && Math.abs(this.value) < 180);
      
      if (isLatLng) {
        console.log(`[SFormElementNumberInput] Auto-detected lat/lng field: ${this.element.name}, using step=0.000001`);
        return 0.000001; // 6 decimalen precision voor lat/lng
      }
      
      // Default fallback
      return 1;
    },
    elementChanged() {
      const rawValue = this.$refs['inputField_' + this.element.name].value;
      // Converteer naar een getal (als het veld leeg is, stuur undefined)
      const numericValue = rawValue === '' ? undefined : Number(rawValue);
      this.$emit('elementChanged', this.element.name, numericValue);
    },
    checkFieldValidity(fieldRef) {
      const field = this.$refs[fieldRef];
      return field && field.checkValidity();
    },
    getTextFor(data, lang) {
      return data ? data[lang] : '';
    }
  },

}
</script>
